// extracted by mini-css-extract-plugin
export var arrows = "_2n-5";
export var decrementer = "_2n-9";
export var disabled = "_2n-3";
export var error = "_2n-1";
export var hiddenText = "_2n-a";
export var incrementer = "_2n-8";
export var input = "_2n-7";
export var inputWrapper = "_2n-0";
export var leadingIcon = "_2n-b";
export var readonly = "_2n-2";
export var regular = "_2n-6";
export var small = "_2n-4";